import React from 'react'
import ReactDOM from 'react-dom/client'
import './styles.css'
import { installChunkLoadRecovery } from './lib/chunkRecovery'
import { registerPortalServiceWorker } from './lib/pwa'
import PortalApp from './PortalApp'

installChunkLoadRecovery()

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('KIS Rx portal root element not found')

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <PortalApp />
  </React.StrictMode>
)

registerPortalServiceWorker().catch(error => {
  console.warn('[PWA] Service worker registration failed:', error)
})
